import { render } from "./Connect.vue?vue&type=template&id=2b844ccc&scoped=true"
import script from "./Connect.vue?vue&type=script&lang=js"
export * from "./Connect.vue?vue&type=script&lang=js"

import "./Connect.vue?vue&type=style&index=0&id=2b844ccc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b844ccc"]])

export default __exports__